import '@modules/select';
import {AoflElement, property, customElement} from '@aofl/element';
import styles from './styles.css';
import {template} from './template';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '../../constants-enumerate';
import '../tabs-sdo';

/**
 * @summary TabHeader
 * @class TabHeader
 * @extends {AoflElement}
 */
@customElement('tab-header')
class TabHeader extends mapStatePropertiesMixin(AoflElement) {
  /**
   * Creates an instance of TabHeader.
   * @memberof TabHeader
   */
  constructor() {
    super();
    this.storeInstance = storeInstance;
  }

  /**
   * @readonly
   * @static
   * @memberof TabHeader
   */
  static is = 'tab-header';

  @property({type: String})
  groupId = 'ungrouped';
  @property({type: Boolean, reflect: true})
  selected = false;

  /**
   *
   *
   * @memberof TabHeader
   */
  mapStateProperties() {
    const state = this.storeInstance.getState();
    this.selected = state[sdoNs.TABS][this.groupId]?.$selected;
  }

  /**
   *
   *
   * @return {Object}
   * @memberof TabHeader
   */
  render() {
    return super.render(template, [styles]);
  }

  /**
   *
   *
   * @param {*} e
   * @memberof TabHeader
   */
  tabChanged(e) {
    const payload = {
      groupId: this.groupId,
      tabId: e.target.value
    };
    this.storeInstance.commit({
      namespace: sdoNs.TABS,
      mutationId: 'select',
      payload
    });
    this.dispatchEvent(new CustomEvent('tab-change', {
      detail: payload
    }));
  }
}

export {
  TabHeader
};
